export * from "@/ui/components/form/Label/Label";
export * from "@/ui/components/form/Label/Label.config";
